import { getErrorMessage } from '../../errorBuilder';
import { get } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getAdminDashboardStats = async () => {
  const builder = new UrlBuilder(`/manage/clients/get-statistics`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
